import { Button, breakpoints } from "@brightagency/headstart-common";
import { ButtonProps } from "@brightagency/headstart-common/dist/button";
import React, { FC } from "react";
import styled from "styled-components";
import { ButtonWidthManager } from "..";

const TextButtonGroupInner = styled.div`
    margin: 32px 0 0;
`;

const TextButtonGaps = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    ${breakpoints.medium} {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;

        button{
            flex-basis: 49%;
        }
    }
    
    &.selection-container{
         ${breakpoints.medium} {
            justify-content: space-between;
        }
    }
`;

const TextButtonGroupTitle = styled.p`
    margin-bottom: 16px;
`;

export const TextButtonGroup: FC<{ className?: string, title?: string }> = props => {
    return (
        <TextButtonGroupInner>
            {props.title && <TextButtonGroupTitle>{props.title}</TextButtonGroupTitle>}
            <ButtonWidthManager className="buttonManager">
                <TextButtonGaps className={props.className}>{props.children}</TextButtonGaps>
            </ButtonWidthManager>
        </TextButtonGroupInner>
    );
};

type TextButtonProps = Partial<ButtonProps> & {
    [key: string]: unknown;
};

export const TextButton: React.FC<TextButtonProps> = props => {
    return <Button shape="rounded" maxWidth={-1} appearance="faded" {...props} />;
};
